import { Rectangle, Vector2 } from "../../math";
import { Alt1Color } from "../Alt1Color";
import { ScreenRectangle } from "../ScreenRectangle";
import { Log } from "../../util/Log";
import { FakeLodash } from "../../coreutil/FakeLodash";
export var Alt1OverlayDrawCalls;
(function (Alt1OverlayDrawCalls) {
    var log = Log.log;
    class Buffer {
        constructor(primitives) {
            this.primitives = primitives;
        }
        playback(alive_time = 30000) {
            for (let element of this.primitives) {
                switch (element.type) {
                    case "rect":
                        const origin = Rectangle.screenOrigin(element.rect);
                        alt1.overLayRect(element.options.color.for_overlay, Math.round(origin.x), Math.round(origin.y), Math.round(Rectangle.width(element.rect)), Math.round(Rectangle.height(element.rect)), alive_time, element.options.width ?? 3);
                        break;
                    case "line":
                        alt1.overLayLine(element.options.color.for_overlay, element.options.width, Math.round(element.from.x), Math.round(element.from.y), Math.round(element.to.x), Math.round(element.to.y), alive_time);
                        break;
                    case "text":
                        alt1.overLayTextEx(element.text, element.options.color.for_overlay, element.options.width ?? 20, Math.round(element.position.x), Math.round(element.position.y), alive_time, undefined, element.options.centered ?? true, element.options.shadow ?? true);
                        break;
                }
            }
            return this;
        }
    }
    Alt1OverlayDrawCalls.Buffer = Buffer;
    let StrokeOptions;
    (function (StrokeOptions) {
        StrokeOptions.DEFAULT = {
            width: 2,
            color: Alt1Color.red
        };
    })(StrokeOptions = Alt1OverlayDrawCalls.StrokeOptions || (Alt1OverlayDrawCalls.StrokeOptions = {}));
    let TextOptions;
    (function (TextOptions) {
        TextOptions.DEFAULT = {
            width: 20,
            color: Alt1Color.red,
            centered: true,
            shadow: true
        };
    })(TextOptions = Alt1OverlayDrawCalls.TextOptions || (Alt1OverlayDrawCalls.TextOptions = {}));
    class GeometryBuilder {
        constructor() {
            this.primitives = [];
        }
        buffer() {
            return new Buffer([...this.primitives]);
        }
        rectangle(rect, options = Alt1OverlayDrawCalls.StrokeOptions.DEFAULT) {
            if (Number.isNaN(rect.origin.x) || Number.isNaN(rect.origin.y) || Number.isNaN(rect.size.x) || Number.isNaN(rect.size.y) || Number.isNaN(options.width)) {
                log().log(`Invalid alt1 overlay line ${rect.size.x}x${rect.size.y}@${rect.origin.x}|${rect.origin.y} (stroke ${options.width})`);
                log().log(Error().stack);
                return this;
            }
            this.primitives.push({ type: "rect", rect: ScreenRectangle.toRectangle(rect), options: options });
            return this;
        }
        line(from, to, options = Alt1OverlayDrawCalls.StrokeOptions.DEFAULT) {
            if (Number.isNaN(from.x) || Number.isNaN(from.y) || Number.isNaN(to.x) || Number.isNaN(to.y) || Number.isNaN(options.width)) {
                log().log(`Invalid alt1 overlay line ${from.x}|${from.y} -> ${to.x}|${to.y} (stroke ${options.width})`);
                log().log(Error().stack);
                return this;
            }
            this.primitives.push({ type: "line", from: from, to: to, options: options });
            return this;
        }
        polyline(points, close = false, stroke = Alt1OverlayDrawCalls.StrokeOptions.DEFAULT) {
            for (let i = 0; i < points.length; i++) {
                const next = (i + 1) % points.length;
                if (next == 0 && !close)
                    break;
                let from = points[i];
                let to = points[next];
                const dir = Vector2.normalize(Vector2.sub(to, from));
                from = Vector2.add(from, Vector2.scale(-(stroke.width ?? 2) / 3, dir));
                to = Vector2.add(to, Vector2.scale((stroke.width ?? 2) / 3, dir));
                this.line(from, to, stroke);
            }
            return this;
        }
        circle(circle, resolution = 8, stroke = Alt1OverlayDrawCalls.StrokeOptions.DEFAULT) {
            const points = [];
            for (let i = 0; i < resolution; i++) {
                const alpha = (i / resolution) * 2 * Math.PI;
                points.push({
                    x: circle.center.x + ~~(Math.cos(alpha) * circle.radius),
                    y: circle.center.y + ~~(Math.sin(alpha) * circle.radius)
                });
            }
            this.polyline(points, true, stroke);
            return this;
        }
        progressbar(center, length, progress, thickness = 5, contrast_border = 2, done_color = Alt1Color.green, remaining_color = Alt1Color.red) {
            const start = Vector2.add(center, { x: -Math.floor(length / 2), y: 0 });
            const end = Vector2.add(start, { x: length, y: 0 });
            const mid = Vector2.snap(Vector2.add(start, { x: FakeLodash.clamp(progress, 0, 1) * length, y: 0 }));
            this.line(Vector2.add(start, { x: -contrast_border, y: 0 }), Vector2.add(end, { x: contrast_border, y: 0 }), { color: Alt1Color.black, width: thickness + 2 * contrast_border });
            this.line(start, mid, { color: done_color, width: thickness });
            this.line(mid, end, { color: remaining_color, width: thickness });
        }
        text(text, position, options = Alt1OverlayDrawCalls.TextOptions.DEFAULT) {
            this.primitives.push({
                type: "text",
                text: text,
                position: position,
                options: options
            });
            return this;
        }
    }
    Alt1OverlayDrawCalls.GeometryBuilder = GeometryBuilder;
})(Alt1OverlayDrawCalls || (Alt1OverlayDrawCalls = {}));
